import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useLocation, useNavigate } from 'react-router-dom';
import UsersTable from './UsersTable';

const DeviceManagement = () => {
  const location = useLocation();
  const hasQueryParams = new URLSearchParams(location.search).toString() !== '';

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Device Management" dropdown={2} showBackButton={hasQueryParams} />

        <Card className="flex-1" bgColor="rgb(7, 7, 7)" border={true} borderColor="#474646" borderSide="left">
          <UsersTable />
        </Card>
      </div>
    </div>
  );
};

export default DeviceManagement;
